var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column h-100 mh-100",
      attrs: { id: "content" },
    },
    [
      _vm._t("secondary-nav"),
      _vm._v(" "),
      _vm._t("main-canvas-ad"),
      _vm._v(" "),
      _vm._t("main-canvas"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }